export const nameReducer = 'CUParameters';
